import React, { useEffect } from "react";
import { headChat } from "../../assets/image";
import { User } from "../../assets/svg/AllSvg";
import { useDispatch, useSelector } from "react-redux";
import { getOnGoingServiceRequests } from "../../redux/serviceRequest/slice";
import { Badge } from "../../components/micro";
import moment from "moment";
import RippleLoader from "../../commons/RippleLoader";
import DataNotFound from "../../commons/DataNotFound";
import { useNavigate } from "react-router-dom";

const OnGoingService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getCompanyID = sessionStorage.getItem("companyID");

  // Selector
  const serviceSettingList = useSelector(
    (store) => store?.serviceRequestData?.getOnGoingServiceRequestsStatus?.data
  );
  const serviceSettingLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Get On Going Service Requests API Call
  useEffect(() => {
    if (getCompanyID) {
      dispatch(
        getOnGoingServiceRequests({
          status: "processing",
          company_id: getCompanyID,
          pageCount: "",
          pageLimit: "",
        })
      );
    }
  }, [dispatch, getCompanyID]);
  return (
    <div className="space-y-5">
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <p className="text-4xl font-ebGaramond">
          Your On-Going Service Requests
        </p>
      </div>
      <p className="text-2xl font-ebGaramond">Latest Request</p>
      {serviceSettingLoading ? (
        <RippleLoader />
      ) : (
        <>
          {serviceSettingList?.length ? (
            <>
              {serviceSettingList?.map((element, index) => {
                return (
                  <div
                    className="hover:card border !rounded-lg space-y-3 p-4 hover:bg-light_secondary_shades"
                    key={index}
                  >
                    <div className="flex md:flex-row flex-col gap-2 md:items-center justify-between">
                      <p className="lg:text-xl text-base font-ebGaramond text-theme">
                        {element?.service?.service_name} (New Request)
                      </p>
                      <div className="flex items-center gap-3">
                        <p className="text-sm font-semibold text-light_grey">
                          Created on{" "}
                          {moment(element?.created_at).format(
                            "DD/MM/YYYY | HH:MM"
                          )}
                        </p>
                        {element?.priority && (
                          <Badge
                            value={`${element?.priority} Priority`}
                            className={`${
                              element?.priority === "high"
                                ? "border-red bg-red"
                                : element?.priority === "mid"
                                ? "border-orange-600 bg-orange-600"
                                : "border-secondary_color bg-secondary_color"
                            }
                      " text-white whitespace-nowrap capitalize text-xs !px-2 !py-0.5"`}
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <p className="text-sm text-light_grey">Current Status:</p>
                      <Badge
                        value={element?.status}
                        className={`${
                          element?.status === "billing_needed"
                            ? "border-orange-600 bg-orange-600 text-white"
                            : element?.status === "expired"
                            ? "border-orange-600 text-orange-600"
                            : element?.status === "pending"
                            ? "border-theme text-light_green"
                            : element?.status === "completed"
                            ? "text-light_green border-light_green"
                            : element?.status === "cancelled"
                            ? "border-red text-red"
                            : "border-theme text-theme"
                        } text-xs !px-2 capitalize !py-0.5`}
                      />
                    </div>
                    <div>
                      <p className="text-theme sm:text-base text-sm">
                        {element?.company?.name}
                      </p>
                      <p className="text-theme sm:text-sm text-xs">
                        {element?.user?.full_name}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-light_grey mb-1">
                        Handled By:
                      </p>
                      <div className="flex justify-between gap-2 items-center">
                        <div className="flex items-center space-x-2 w-full">
                          <div className="max-w-8 w-full h-8 flex justify-center items-center bg-grey rounded-full">
                            {element?.handled_by?.profile_path ? (
                              <img
                                src={element?.handled_by?.profile_path}
                                alt="profile"
                                className="w-full h-full object-cover"
                              />
                            ) : (
                              <User pathClass="fill-white" fillOpacity={1} />
                            )}
                          </div>
                          <p className="text-theme border-b border-theme">
                            {element?.handled_by?.full_name}
                          </p>
                        </div>
                        <button
                          className="text-theme border-b border-theme sm:text-base whitespace-nowrap text-xs"
                          onClick={() =>
                            navigate("/service-request-details", {
                              state: element,
                            })
                          }
                        >
                          Open Request
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <DataNotFound />
          )}
        </>
      )}
    </div>
  );
};

export default OnGoingService;
